<div class="content-wrapper" >
    <div class="col-12 grid-margin stretch-card" *ngIf="!hasUserApprovedContract">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Approve Request</h4>
          <form class="forms-sample" #ngNewContractForm="ngForm" name="form"
            >
  
            <div class="row">
              <!-- Location  
              <div class="col">
                <div class="form-group">
                  <label for="location">Location</label>
                  <select class="form-control" required [(ngModel)]="selectedLocationId" name="selectedLocationId"
                    id="selectedLocationId">
                    <option value="">--Select Location--</option>
                    <option [value]="location.id" *ngFor="let location of Locations">{{location.name}} </option>
                  </select>
                </div>
              </div>
  -->

              <div class="col">
                <div class="form-group">
                  <label for="costCenter">        <b>Requester :</b></label>
                  <p>{{ UpdateRequest?.createdBy  }}</p>
                </div>
              </div>
              <!-- Cost Center  -->
              <div class="col">
                <div class="form-group">
                  <label for="costCenter">        <b>Cost Center:</b></label>
                   <p>{{ UpdateRequest?.costCenterName  }}</p>
                </div>
              </div>
  
            </div>
  
            <div class="row">
              <!-- Number of Staff  -->
              <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1"><b> Number of Staff: </b></label>
                   <p>{{ UpdateRequest?.noOfStaff  }}</p>
                
                </div>
              </div>

              <!-- Mode of HeadCount  -->
              <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1"><b> Mode Of HeadCount: </b></label>
                   <p>{{ UpdateRequest?.modeOfHeadCount  }}</p>
                
                </div>
              </div>
  
              
            </div>
  
            <div class="row">
              <!-- Contract Duration  -->
              <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1"><b>Contract Duration (Month): </b></label>
                  <p>{{ UpdateRequest?.contractDuration  }}</p>
               
                </div>
              </div>

              <!-- Total Cost  -->
              <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1"><b>Budget Cost: </b></label>
                  <p>{{ UpdateRequest?.budgetCost  }}</p>
                 
                </div>
              </div>
  
              <!-- Expected Start Date  -->
              <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1"><b>Expected Start Date: </b></label>
                  
                  <p>{{ UpdateRequest?.expectedStartDate  }}</p>
                </div>
              </div>
            </div>
  
  
            <div class="row">
              <!-- Description  -->
              <div class="col">
                <div class="form-group">
                  <label for="exampleTextarea1"><b>Job Description </b></label>
                  <textarea class="form-control" id="description" rows="4" name="description" [(ngModel)]="description"
                    required #Edescription="ngModel" readonly></textarea>
  
                 
                </div>
              </div>
  
              <!-- Justification  -->
              <div class="col">
                <div class="form-group">
                  <label for="justification"><b>Justification</b></label>
                  <textarea class="form-control" id="justification" rows="4" name="justification"
                    [(ngModel)]="justification" required #Ejustification="ngModel" readonly></textarea>
  
                 
                </div>
              </div>
  
              <!-- Qualification  -->
              <div class="col">
                <div class="form-group">
                  <label for="justification"><b>Qualification & Experience</b></label>
                  <textarea class="form-control" id="qualification" rows="4" name="qualification"
                    [(ngModel)]="qualification" required #Equalification="ngModel" readonly></textarea>
  
                 
                </div>
              </div>
            </div>
  
      <div class="row">

            <div class="col" *ngIf="UpdateRequest?.axiom != ''">
              <label><b>Axiom</b></label>
              <p>{{ UpdateRequest?.axiom }}</p>
            </div>

            <div class="col" *ngIf="isHrbp">
                <div class="form-group">
                  <label for="selectedAxiom"><b>Select Axiom</b></label>
                  <select class="form-control" required [(ngModel)]="axiomId" name="axiomId"
                    id="axiomId"  (ngModelChange)="onChangeAxiom($event)">
                    <option value="">-- Select Axiom --</option>
                    <option [value]="axiom.id" *ngFor="let axiom of axioms">{{axiom.name}}
                    </option>
                  </select>
                  
                </div>
              </div>
 <!-- Comment  -->
 <div class="col">
    <div class="form-group">
      <label for="exampleTextarea1"><b>Comment</b></label>
      <textarea class="form-control" id="Comment" rows="4" name="Comment" [(ngModel)]="Comment"
        required #EComment="ngModel" ></textarea>

     
    </div>
  </div>

      </div>

            <hr>
          
                <!-- Approvals -->
   <div class="card-body" >
    <h5 class="card-title">Approvals</h5>
    <div class="table-responsive" >
      <table class="table table--striped table-hover">
        <thead>
          <tr>

            <th>
              Approved By
            </th>
            <th>
              Date Approved
            </th>
            <th>
              Message
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let approval of RequestApprovals">

            <td>{{approval.approvedBy}}</td>
            <td>{{approval.dateOfApproval | date: 'dd MMMM yyyy hh:mm a'}}</td>
            <td>{{approval.message}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!RequestApprovals?.length"
      style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
      <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
    </div>
    <!-- Approvals -->
  </div>
           
          
  
  
            <hr>
            <div >
                <div style="float: right" class="d-print-none">
                
                  <a   
                  (click)="approveContract()"
                  (nzOnCancel)="cancelReturn()"
                  > 
                    <span style="margin-right: 8px;" class="btn btn-primary">
                        Approve
                    </span>
                </a> 
                
                <a  
                (click)="rejectContract()"
                (nzOnCancel)="cancelReturn()"
                > 
                  <span style="margin-right: 8px;"class="btn btn-danger">
                      Reject
                  </span>
              </a> 
                  
                  
               
                </div>
            </div>
          </form>
        </div>
      </div>
    </div>


    <div class="content-wrapper" *ngIf="hasUserApprovedContract">
        <div class="row">
          <div class="col-lg-12 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title"> </h4>
             
      
                <div  style="text-align: center; padding: 18px;">
                  <h4 style="color: rgba(128, 128, 128, 0.741); ">This request has been approved</h4>
                </div>

                              <!-- Approvals -->
   <div class="card-body" >
    <h5 class="card-title">Approvals</h5>
    <div class="table-responsive" >
      <table class="table table--striped table-hover">
        <thead>
          <tr>

            <th>
              Approved By
            </th>
            <th>
              Date Approved
            </th>
            <th>
              Message
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let approval of RequestApprovals">

            <td>{{approval.approvedBy}}</td>
            <td>{{approval.dateOfApproval | date: 'dd MMMM yyyy hh:mm a'}}</td>
            <td>{{approval.message}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div  style="text-align: center; padding: 18px;">
        <button class="btn btn-primary" style="margin-right: 8px;"  (click)="cancel()">Close</button>
      </div>


    <div *ngIf="!RequestApprovals?.length"
      style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
      <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
    </div>
    <!-- Approvals -->
  </div>
         
              </div>
            </div>
          </div>
      
      
        </div>
      </div>